import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import imgnotavailableImg from '@/assets/images/products/imgnotavailable.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaSuperplastSCC = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Superplast - SCC"
        subTitle="(High Performance Superplasticizer For Self Compacting Concrete)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          title="Description"
          imageUrl={imgnotavailableImg}
          content="Vista Superplast SCC is a high-performance superplasticizer used to produce self-compacting concrete with high consistence values. It is particularly useful in precast operations, flooring, and when pouring into intricate or heavily congested areas of reinforcement. Vista Superplast SCC enhances cement dispersion, creating non-shrinkable concrete with high water reduction and workability retention. It conforms to IS: 9103: 1999 (Reaffirmed 2004) and ASTM C494, Type F."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <Paragraph content="Vista Superplast SCC is suitable for concrete where high early and ultimate strengths are required. It has been developed for use in:" />
          <CustomLists
            items={[
              [
                "Self-compacting concrete.",
                "Pumped concrete.",
                "Concrete with extreme water reduction and excellent flowability with optimal cohesion.",
              ],
              [
                "Pre-cast concrete.",
                "High-performance and high-strength concrete.",
                "Concrete requiring long workability and retention.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Strong self-compacting behavior.",
                "Developed early strength.",
                "Increases durability.",
                "Improved adhesion to reinforcing and stressing steel.",
                "Water reduction up to 40%. Higher percentage of water reduction can be achieved depending on mix design.",
              ],
              [
                "Increases flexural strength.",
                "Reduces permeability.",
                "Reduces shrinkage and creep.",
                "Reduces the rate of carbonation of the concrete.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Aspect", "Brown Liquid"],
                ["Specific Gravity", "1.08 +/- 0.02"],
                ["Chloride Content", "NIL (As Per BS 5075)"],
                ["pH", "≥ 6"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Precaution">
          <Paragraph content="Vista Superplast SCC is non-toxic, non-flammable, eco-friendly, and harmless. Any splashes on the skin should be washed immediately with water." />
          <Paragraph content="NOTE: Overdosing of the material may cause a delay in setting of the concrete." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaSuperplastSCC;
